import React from 'react'

import { useAllBrandAccountsQuery } from './useAllBrandAccountsQuery'

export const useAllBrandAccounts = () => {
  const { data } = useAllBrandAccountsQuery()

  return React.useMemo(() => data ?? [], [data])
}
